var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { CONFIG_LOCAL } from "./app.config.local";
// Local APIs of the `local_prod_db` Docker environment: your own legacy and
// next API, running against the PRODUCTION database. Only the ports differ from
// CONFIG_LOCAL -- every Docker environment publishes its own.
export var CONFIG_LOCAL_PROD = __assign(__assign({}, CONFIG_LOCAL), { BASE_URL_V1: "http://localhost:3140/v1", BASE_URL_V2: "http://localhost:3440/v2", URL_SOCKETS: "ws://localhost:3140/v1/websocket?access_token={{accessToken}}&locale={{locale}}" });
